import type { FormEvent } from 'react'
import { s, h } from '../lib/sx'
import { PageHero } from '../components/PageHero'
import { copy } from '../content/copy'
import { jobs } from '../content/jobs'

const inputStyle = s('width:100%;padding:13px 14px;border:1px solid #C3C9D1;background:#F2F4F6;font-size:14px;margin-bottom:10px;outline:none;')

export interface CareersProps {
  openJob: string | null
  setOpenJob: (id: string | null) => void
  applied: boolean
  setApplied: (v: boolean) => void
}

export function Careers({ openJob, setOpenJob, applied, setApplied }: CareersProps) {
  /**
   * NOT WIRED TO A BACKEND. This only flips the panel to its confirmation state,
   * exactly as the prototype did — nothing is sent, stored or emailed. Connect a
   * form handler before this page is published, or a real application will be
   * silently discarded. See README.md § Forms.
   */
  const apply = (e: FormEvent) => {
    e.preventDefault()
    setApplied(true)
  }

  return (
    <div>
      <PageHero eyebrow="Careers" title={copy.careers.headline} sub={copy.careers.sub} />

      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,64px) clamp(18px,4vw,32px) 100px;')}>
        <div style={s('display:flex;justify-content:space-between;align-items:baseline;gap:24px;margin-bottom:32px;')}>
          <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(24px,3vw,32px);letter-spacing:-0.025em;margin:0;')}>Open positions</h2>
          <span style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.14em;color:#7E8894;text-transform:uppercase;")}>
            {jobs.length} {jobs.length === 1 ? 'vacancy' : 'vacancies'}
          </span>
        </div>

        <div style={s('border-top:2px solid #1B2430;')}>
          {jobs.map((j) => {
            const open = openJob === j.id
            return (
              <div key={j.id} style={s('border-bottom:1px solid #DCE0E5;')}>
                <button
                  onClick={() => setOpenJob(open ? null : j.id)}
                  aria-expanded={open}
                  style={s('width:100%;background:transparent;border:0;cursor:pointer;text-align:left;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,150px),1fr));gap:16px;align-items:center;padding:26px 12px;')}
                  className={h('background:#E7EAEE;')}
                >
                  <span style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:20px;letter-spacing:-0.01em;color:#1B2430;')}>{j.title}</span>
                  <span style={s('font-size:14px;color:#566070;')}>{j.loc}</span>
                  <span style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#7E8894;")}>{j.type}</span>
                  <span style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;color:#7E8894;")}>Closes {j.close}</span>
                  <span style={s('font-size:20px;color:#A8500F;text-align:right;')}>{open ? '−' : '+'}</span>
                </button>

                {open && (
                  <div style={s('padding:8px 12px 40px;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,300px),1fr));gap:clamp(32px,4vw,56px);')}>
                    <div>
                      <p style={s('font-size:16px;line-height:1.65;color:#38424E;margin:0 0 22px;')}>{j.desc}</p>
                      <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#7E8894;margin-bottom:12px;")}>Requirements</div>
                      {j.reqs.map((rq, i) => (
                        <div key={i} style={s('font-size:15px;line-height:1.5;color:#1B2430;padding:8px 0;border-bottom:1px solid #DCE0E5;')}>
                          {rq}
                        </div>
                      ))}
                    </div>

                    <div style={s('background:#DCE0E5;padding:30px 28px;')}>
                      {applied ? (
                        <div>
                          <div style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:22px;margin-bottom:10px;')}>Application received</div>
                          <p style={s('font-size:15px;line-height:1.6;color:#38424E;margin:0;')}>{copy.careers.applyConfirmation}</p>
                        </div>
                      ) : (
                        <form onSubmit={apply}>
                          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#66707C;margin-bottom:18px;")}>Apply for this role</div>
                          <input placeholder="Full name" required style={inputStyle} />
                          <input placeholder="Email address" type="email" required style={inputStyle} />
                          <input placeholder="Mobile number" style={inputStyle} />
                          <input placeholder="Link to CV (Drive, Dropbox…)" style={s('width:100%;padding:13px 14px;border:1px solid #C3C9D1;background:#F2F4F6;font-size:14px;margin-bottom:16px;outline:none;')} />
                          <button type="submit" style={s('width:100%;background:#1B2430;color:#F2F4F6;border:0;padding:15px;font-size:14px;font-weight:600;cursor:pointer;')} className={h('background:#1F5C99;')}>
                            Submit application
                          </button>
                        </form>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </section>
    </div>
  )
}
